(function () {
  'use strict';

  var TOKEN = 'k8mQ2vNx9pLr4wZbT6hJcY3fD1sA7eU5';

  /** Canonical WebEngage event names — do not invent one-offs. */
  var WE_MODE_EVENTS = {
    known_user_general: 'Known User - General',
    known_user_upliance: 'Known User - Upliance',
    known_user_air_fryer: 'Known User - Air Fryer'
  };

  if (!window.__ps5youc) window.__ps5youc = {};
  window.__ps5youc.WE_MODE_EVENTS = WE_MODE_EVENTS;

  function digitsOnly(str) {
    return (str || '').replace(/[^0-9]/g, '');
  }

  function getTrackingParams() {
    var params = new URLSearchParams(window.location.search || '');
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      channel: params.get('channel') || '',
      fbclid: params.get('fbclid') || '',
      gclid: params.get('gclid') || '',
      gbraid: params.get('gbraid') || '',
      wbraid: params.get('wbraid') || ''
    };
  }

  var SHEET_TAB_BY_FORM_TYPE = {
    bulk_order: 'BulkOrders',
    site_lead_capture: 'LeadCaptureForms',
    product_callback: 'ProductPages'
  };

  var PHONE_LENGTH_BY_COUNTRY = {
    '+91': 10,
    '+1': 10,
    '+44': 10,
    '+971': 9,
    '+61': 9
  };

  function makeLeadId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function nationalPhoneDigits(phoneInput, countryCode) {
    var raw = asString(phoneInput);
    var digits = digitsOnly(raw);
    var code = asString(countryCode) || '+91';
    var codeDigits = digitsOnly(code);
    var expectedLength = PHONE_LENGTH_BY_COUNTRY[code] || 10;

    if (raw.charAt(0) === '+') {
      if (!codeDigits || digits.indexOf(codeDigits) !== 0) return '';
      digits = digits.slice(codeDigits.length);
    } else if (codeDigits && digits.indexOf(codeDigits) === 0) {
      var withoutCallingCode = digits.slice(codeDigits.length);
      var hasNationalTrunkPrefix = withoutCallingCode.charAt(0) === '0'
        && withoutCallingCode.length === expectedLength + 1;
      if (withoutCallingCode.length === expectedLength || hasNationalTrunkPrefix) {
        digits = withoutCallingCode;
      }
    }

    if (code !== '+1' && digits.charAt(0) === '0') digits = digits.slice(1);
    return digits;
  }

  function isValidPhoneNumber(phoneInput, countryCode) {
    var code = asString(countryCode) || '+91';
    var expectedLength = PHONE_LENGTH_BY_COUNTRY[code] || 10;
    return new RegExp('^[1-9][0-9]{' + (expectedLength - 1) + '}$').test(
      nationalPhoneDigits(phoneInput, code)
    );
  }

  function normalizePhone(phoneInput, countryCode) {
    var code = asString(countryCode) || '+91';
    var normalizedCode = code.charAt(0) === '+' ? code : '+' + code;
    var digits = nationalPhoneDigits(phoneInput, normalizedCode);
    return normalizedCode + digits;
  }

  function buildLeadPayload(input) {
    input = input || {};
    var extra = input.extraPayload || {};
    var tracking = input.tracking || getTrackingParams();
    var root = input.root || null;
    var formType = asString(input.formType || (root && root.getAttribute('data-form-type')) || 'site_lead_capture');
    var source = asString(input.source || (root && root.getAttribute('data-lead-source')));
    var formId = asString(input.formId || (root && root.getAttribute('data-form-id')) || (root && root.id) || source);
    var phoneInput = asString(input.phoneInput);
    var phoneCountryCode = asString(input.phoneCountryCode) || '+91';
    var pageUrl = '';
    var pagePath = '';
    try {
      pageUrl = window.location.href || '';
      pagePath = window.location.pathname || '';
    } catch (e) {}

    return {
      lead_id: asString(input.leadId) || makeLeadId(),
      submitted_at_utc: new Date().toISOString(),
      name: asString(input.name),
      phone_e164: asString(input.phoneE164) || normalizePhone(phoneInput, phoneCountryCode),
      source: source,
      form_id: formId,
      page_url: pageUrl,
      page_path: pagePath,
      utm_source: asString(tracking.utm_source),
      utm_medium: asString(tracking.utm_medium),
      utm_campaign: asString(tracking.utm_campaign),
      utm_content: asString(tracking.utm_content),
      utm_term: asString(tracking.utm_term),
      source_site: asString(input.sourceSite || (root && root.getAttribute('data-source-site'))) || 'upliance_shopify',
      form_type: formType,
      referrer: document.referrer || '',
      gclid: asString(tracking.gclid),
      fbclid: asString(tracking.fbclid),
      gbraid: asString(tracking.gbraid),
      wbraid: asString(tracking.wbraid),
      phone_input: phoneInput,
      phone_country_code: phoneCountryCode,
      email: asString(extra.email),
      company: asString(extra.company),
      product_interest: asString(extra.product_interest),
      quantity: asString(extra.quantity),
      product_id: asString(extra.product_id),
      product_handle: asString(extra.product_handle),
      product_title: asString(extra.product_title),
      recipe_id: asString(extra.recipe_id),
      recipe_name: asString(extra.recipe_name),
      recipe_url: asString(extra.recipe_url),
      marketing_consent_status: asString(extra.marketing_consent_status) || 'not_requested',
      whatsapp_consent_status: asString(extra.whatsapp_consent_status) || 'not_requested',
      consent_captured_at_utc: asString(extra.consent_captured_at_utc)
    };
  }

  function targetTabForFormType(formType) {
    return SHEET_TAB_BY_FORM_TYPE[asString(formType)] || '';
  }

  window.UplianceLeadIntake = window.UplianceLeadIntake || {};
  window.UplianceLeadIntake.buildPayload = buildLeadPayload;
  window.UplianceLeadIntake.targetTabForFormType = targetTabForFormType;
  window.UplianceLeadIntake.nationalPhoneDigits = nationalPhoneDigits;
  window.UplianceLeadIntake.isValidPhoneNumber = isValidPhoneNumber;
  window.UplianceLeadIntake.normalizePhone = normalizePhone;

  /**
   * Resolve the canonical WebEngage event plus an explicitly enabled legacy event.
   * Unknown modes use General; a blank legacy name never creates a second event.
   */
  function resolveWeEvents(config) {
    config = config || {};
    var mode = String(config.weMode || '').trim();
    var primary = WE_MODE_EVENTS[mode] || '';
    if (!primary) {
      primary = WE_MODE_EVENTS.known_user_general;
    }

    var events = [primary];
    var dualFire = config.dualFireLegacy === true || config.dualFireLegacy === 'true';
    var legacy = String(config.legacyWeEvent || '').trim();
    if (dualFire && legacy && legacy !== primary) {
      events.push(legacy);
    }
    return events;
  }

  window.__ps5youc.resolveWeEvents = resolveWeEvents;

  function trackKnownUserEvent(fullPhone, countryCode, tracking, config, leadPayload) {
    if (!window.webengage || typeof window.webengage.track !== 'function') return;
    try {
      var attribution = tracking || {};
      var utmSource = attribution.utm_source || 'direct';
      var utmMedium = attribution.utm_medium || 'none';
      var utmCampaign = attribution.utm_campaign || '';
      var utmChannel = attribution.channel || '';
      var leadTag = config.leadTag || config.source || '';
      var leadName = config.leadName || '';
      var pagePath = '';
      try {
        pagePath = window.location.pathname || '';
      } catch (e0) {}

      if (window.webengage.user && typeof window.webengage.user.login === 'function') {
        window.webengage.user.login(fullPhone || '');
      }

      if (window.webengage.user && typeof window.webengage.user.setAttribute === 'function') {
        var attrs = {
          we_phone: fullPhone || '',
          last_known_source: utmSource,
          last_known_medium: utmMedium,
          last_known_channel: utmChannel,
          last_known_campaign_name: utmCampaign
        };
        if (leadName) attrs.we_first_name = leadName;
        if (leadPayload && leadPayload.email) attrs.we_email = leadPayload.email;
        if (leadPayload && leadPayload.company) attrs.company = leadPayload.company;
        if (leadPayload && leadPayload.product_interest) attrs.product_interest = leadPayload.product_interest;
        window.webengage.user.setAttribute(attrs);
        if (leadPayload && leadPayload.whatsapp_consent_status === 'granted') {
          window.webengage.user.setAttribute('we_whatsapp_opt_in', true);
        } else if (leadPayload && leadPayload.whatsapp_consent_status === 'declined') {
          window.webengage.user.setAttribute('we_whatsapp_opt_in', false);
        }
      }

      var eventProps = Object.assign({
        we_phone: fullPhone || '',
        country_code: countryCode || '',
        utm_source: attribution.utm_source || '',
        utm_medium: attribution.utm_medium || '',
        utm_campaign: attribution.utm_campaign || '',
        utm_term: attribution.utm_term || '',
        utm_content: attribution.utm_content || '',
        utm_channel: utmChannel,
        fbclid: attribution.fbclid || '',
        gclid: attribution.gclid || '',
        gbraid: attribution.gbraid || '',
        wbraid: attribution.wbraid || '',
        source: leadTag,
        page_path: pagePath
      }, leadPayload || {});
      if (leadName) eventProps.we_first_name = leadName;

      var eventNames = resolveWeEvents(config);
      eventNames.forEach(function (weEvent) {
        window.webengage.track(weEvent, eventProps);
      });
    } catch (e) {
      // Do not block UX if tracking fails.
    }
  }

  window.__ps5youc.trackKnownUserEvent = trackKnownUserEvent;

  window.UplianceLeadIntake.trackWebEngage = function (payload, config) {
    payload = payload || {};
    config = config || {};
    var tracking = {
      utm_source: payload.utm_source || '',
      utm_medium: payload.utm_medium || '',
      utm_campaign: payload.utm_campaign || '',
      utm_term: payload.utm_term || '',
      utm_content: payload.utm_content || '',
      fbclid: payload.fbclid || '',
      gclid: payload.gclid || '',
      gbraid: payload.gbraid || '',
      wbraid: payload.wbraid || ''
    };
    trackKnownUserEvent(
      payload.phone_e164 || '',
      payload.phone_country_code || '',
      tracking,
      Object.assign({
        weMode: 'known_user_general',
        source: payload.source || '',
        leadTag: payload.source || '',
        leadName: payload.name || ''
      }, config),
      payload
    );
  };

  function trackLeadEvent(fullPhone, countryCode, config) {
    var leadTag = config.leadTag || config.source || '';
    var includePhone = config.includePhoneInAnalytics !== false;
    try {
      if (typeof fbq !== 'undefined') {
        var metaProps = {
          country: countryCode || '',
          tags: leadTag
        };
        if (includePhone) metaProps.phone = fullPhone || '';
        fbq('track', 'Lead', metaProps);
      }
      if (typeof gtag !== 'undefined') {
        // Google Ads only. Without send_to this event also reached GA4, carrying the phone number
        // (GA4 forbids PII). The phone is never sent to gtag.
        gtag('event', 'Lead', {
          send_to: 'AW-11397548256',
          currency: 'INR',
          value: 1,
          country_code: countryCode || ''
        });
      }
      if (typeof window.uplTrack === 'function') {
        // lead_id (a random UUID, also the sheet row key) joins the lead to the visitor's GA4 behaviour.
        window.uplTrack('generate_lead', {
          lead_source: leadTag,
          form: 'leadcap',
          country_code: countryCode || '',
          lead_id: config.leadId || ''
        });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Lead',
        lead_source: leadTag,
        country_code: countryCode || ''
      });
    } catch (e) {
      // Do not block UX if tracking fails.
    }
  }

  /**
   * @param {Object} config
   * @param {HTMLElement} config.root
   * @param {string} config.source - webhook + analytics source slug
   * @param {string} [config.weMode] - known_user_general | known_user_upliance | known_user_air_fryer
   * @param {string} [config.legacyWeEvent] - optional second event during cutover
   * @param {boolean} [config.dualFireLegacy] - fire legacyWeEvent too (default false unless true)
   * @param {string} [config.leadTag] - Meta/GA tag (defaults to source)
   * @param {boolean} [config.requireWebhook] - block submission when no webhook is configured
   * @param {boolean} [config.trackKnownUser] - skip WebEngage identity/event tracking when false
   * @param {boolean} [config.includePhoneInAnalytics] - omit phone from Meta/GA/dataLayer when false
   * @param {Function} [config.extraPayload] - return additional webhook fields at submit time
   * @param {Object} config.selectors - class names within root
   * @param {string} [config.phonePlaceholder]
   * @param {string} [config.defaultError]
   */
  window.__ps5youc.initLeadcap = function (config) {
    if (!config || !config.root) return null;

    var root = config.root;
    var sel = config.selectors || {};
    var form = root.querySelector(sel.form || '.ps5youc-leadcap__form');
    var countryEl = root.querySelector(sel.country || '.ps5youc-leadcap__country');
    var phoneEl = root.querySelector(sel.phone || '.ps5youc-leadcap__input');
    var nameEl = root.querySelector(sel.name || '.ps5youc-leadcap__name');
    var errEl = root.querySelector(sel.error || '.ps5youc-leadcap__error');
    var okEl = root.querySelector(sel.success || '.ps5youc-leadcap__success');
    var privacyEl = root.querySelector(sel.privacy || '.ps5youc-leadcap__privacy');
    var honeypot = root.querySelector(sel.honeypot || '.ps5youc-leadcap__honeypot');
    var submitBtn = form ? form.querySelector(sel.submit || 'button[type="submit"]') : null;
    var webhookUrl = (root.getAttribute('data-webhook-url') || '').trim();
    var defaultError = config.defaultError || 'Please enter a valid 10-digit mobile number.';
    var phonePlaceholder = config.phonePlaceholder || '';
    var inputErrorClass = config.inputErrorClass || 'ps5youc-leadcap__input--error';

    // Prefer data-* attrs when present (theme editor / Liquid), else config object.
    if (!config.weMode && root.getAttribute('data-we-mode')) {
      config.weMode = root.getAttribute('data-we-mode');
    }
    if (config.dualFireLegacy == null && root.hasAttribute('data-dual-fire-legacy')) {
      config.dualFireLegacy = root.getAttribute('data-dual-fire-legacy') === 'true';
    }
    if (!config.legacyWeEvent && root.getAttribute('data-legacy-we-event')) {
      config.legacyWeEvent = root.getAttribute('data-legacy-we-event');
    }
    if (!config.source && root.getAttribute('data-lead-source')) {
      config.source = root.getAttribute('data-lead-source');
    }

    function showError(message, markPhoneInvalid) {
      if (errEl) {
        errEl.textContent = message || defaultError;
        errEl.hidden = false;
      }
      if (okEl) okEl.hidden = true;
      if (phoneEl && markPhoneInvalid !== false) {
        phoneEl.classList.add(inputErrorClass);
        phoneEl.setAttribute('aria-invalid', 'true');
      }
    }

    function hideError() {
      if (errEl) {
        errEl.textContent = defaultError;
        errEl.hidden = true;
      }
      if (phoneEl) {
        phoneEl.classList.remove(inputErrorClass);
        phoneEl.setAttribute('aria-invalid', 'false');
      }
    }

    function showSuccess() {
      if (form) form.classList.add('is-hidden');
      if (privacyEl) privacyEl.classList.add('is-hidden');
      if (errEl) errEl.hidden = true;
      if (okEl) okEl.hidden = false;
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      if (!submitBtn.dataset.defaultLabel) {
        submitBtn.dataset.defaultLabel = submitBtn.textContent;
      }
      submitBtn.disabled = !!isLoading;
      submitBtn.textContent = isLoading ? 'Submitting...' : submitBtn.dataset.defaultLabel;
      submitBtn.style.opacity = isLoading ? '0.8' : '1';
      submitBtn.style.cursor = isLoading ? 'wait' : 'pointer';
    }

    function onCountryChange() {
      hideError();
    }

    function finishSuccess(fullPhone, code, tracking, leadName, leadPayload) {
      var trackConfig = {
        weMode: config.weMode,
        legacyWeEvent: config.legacyWeEvent,
        dualFireLegacy: config.dualFireLegacy,
        source: config.source,
        leadTag: config.leadTag || config.source,
        leadName: leadName,
        leadId: (leadPayload && leadPayload.lead_id) || '',
        includePhoneInAnalytics: config.includePhoneInAnalytics
      };
      if (config.trackKnownUser !== false) {
        trackKnownUserEvent(fullPhone, code, tracking, trackConfig, leadPayload);
      }
      trackLeadEvent(fullPhone, code, trackConfig);
      if (form) form.reset();
      if (phoneEl && phonePlaceholder && String(phonePlaceholder).trim() !== '') {
        phoneEl.placeholder = phonePlaceholder;
      }
      showSuccess();
    }

    async function onSubmit(e) {
      e.preventDefault();
      hideError();

      // Honeypot: fake success, no sheet / no WebEngage (bots must not pollute journeys).
      if (honeypot && honeypot.value && honeypot.value.trim() !== '') {
        showSuccess();
        return;
      }

      if (form && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var code = countryEl ? countryEl.value : '+91';
      var rawPhone = phoneEl ? phoneEl.value : '';

      if (!isValidPhoneNumber(rawPhone, code)) {
        var expectedLength = PHONE_LENGTH_BY_COUNTRY[code] || 10;
        var phoneError = expectedLength === 10
          ? defaultError
          : 'Please enter a valid ' + expectedLength + '-digit mobile number.';
        showError(phoneError);
        if (phoneEl) phoneEl.focus();
        return;
      }

      var fullPhone = normalizePhone(rawPhone, code);
      var leadName = nameEl ? nameEl.value.trim() : '';
      var tracking = getTrackingParams();
      var pagePath = '';
      try {
        pagePath = window.location.pathname || '';
      } catch (e1) {}

      var extraPayload = {};
      if (typeof config.extraPayload === 'function') {
        try {
          extraPayload = config.extraPayload(root) || {};
        } catch (extraPayloadError) {
          // Optional context must not prevent a callback request.
        }
      }

      var leadPayload = buildLeadPayload({
        root: root,
        formType: config.formType || root.getAttribute('data-form-type') || 'site_lead_capture',
        formId: config.formId,
        sourceSite: config.sourceSite,
        source: config.source,
        name: leadName,
        phoneInput: rawPhone,
        phoneCountryCode: code,
        phoneE164: fullPhone,
        tracking: tracking,
        extraPayload: extraPayload
      });
      var payload = Object.assign({}, leadPayload, {
        token: TOKEN,
        phone: fullPhone,
        channel: tracking.channel || '',
        target_tab: targetTabForFormType(leadPayload.form_type)
      });

      if (!webhookUrl) {
        if (config.requireWebhook !== false) {
          showError('Callback requests are temporarily unavailable. Please try another contact option.', false);
          return;
        }
        finishSuccess(fullPhone, code, tracking, leadName, leadPayload);
        return;
      }

      setLoading(true);
      try {
        await fetch(webhookUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        });
        finishSuccess(fullPhone, code, tracking, leadName, leadPayload);
      } catch (err) {
        showError("Couldn't reach us right now. Please try again.", false);
      } finally {
        setLoading(false);
      }
    }

    function onPhoneInput() {
      if (phoneEl && phoneEl.classList.contains(inputErrorClass)) {
        hideError();
      }
    }

    if (countryEl) countryEl.addEventListener('change', onCountryChange);
    if (form) form.addEventListener('submit', onSubmit);
    if (phoneEl) phoneEl.addEventListener('input', onPhoneInput);

    function sectionUnload(ev) {
      var target = ev.target;
      if (!target || !target.contains || !target.contains(root)) return;
      if (countryEl) countryEl.removeEventListener('change', onCountryChange);
      if (form) form.removeEventListener('submit', onSubmit);
      if (phoneEl) phoneEl.removeEventListener('input', onPhoneInput);
      document.removeEventListener('shopify:section:unload', sectionUnload);
    }

    document.addEventListener('shopify:section:unload', sectionUnload);

    return { destroy: sectionUnload };
  };
})();
